'use strict'
import { serverApi } from '@/server';

export default {

    /**
     * 充值列表
     *
     * @author nick
     *
     * @method GET
     * 
     * 
     * @url /api/recharges
     * 
     * @returns {Promise}
     */
    getRechargesList(formData) {
        const url = `/recharges`
        return serverApi.get(formData, url)
    },
    /**
     * 充值详情
     *
     * @author nick
     *
     * @method GET
     * 
     * 
     * @url /api/recharges/:id
     * 
     * @returns {Promise}
     */
    getRechargesDetail(id) {
        const url = `/recharges/${id}`
        return serverApi.get({}, url)
    },
    /**
     * 预览充值凭证
     *
     * @author nick
     *
     * @param {*} formData
     * @param {*} fileName
     *
     * @returns {Blob}
     */
    previewRechargeRecords(formData) {
        const url = `/preview-recharge-records`;
        return serverApi.post(formData, url)
    },

    /**
     * 下载充值凭证
     *
     * @author nick
     *
     * @param {*} formData
     * @param {*} fileName
     *
     * @returns {Blob}
     */
    downLoad(formData, fileName) {
        const url = `/download-recharge-records`
        return serverApi.downLoadByPost(formData, url, fileName);

    },

}